import './MainPage.scss';
import React, { useEffect } from "react";
import Footer from '../Footer';

const MainPage = () => {

    useEffect(() => {
        // fnc.setCookie('stCode', '100227');
    }, []);

    //=========================================
    return(

        <div className="MainPage">
           
            <div className='wrap-main'>
                <section className='sec-main'>
                    <article className='art-main1'>
                        <p className="display-4">| KUESB |</p>
                        <p className="display-1">공부를 잘하는 방법을 가르칩니다.</p>
                        <p className="display-4">
                            개별 맞춤 진단을 바탕으로 자기주도훈련을 통해
                            <br />혼자서도 공부를 잘하는 방법을 가르칩니다.
                        </p>
                    </article>
                </section>

                <section className='bg_pt_orange'>
                    <article className='art-main2'>
                        <p className="display-1">공부를 잘하는 방법을 가르칩니다.</p>
                        <p className="display-4">
                            개별 맞춤 진단을 바탕으로 자기주도훈련을 통해
                            <br />혼자서도 공부를 잘하는 방법을 가르칩니다.
                        </p>
                    </article>
                </section>

                <section className='bg_pt_purple'>
                    <article className='art-main3'>
                        <p className="display-1">공부를 잘하는 방법을 가르칩니다.</p>
                        <p className="display-4">
                            개별 맞춤 진단을 바탕으로 자기주도훈련을 통해
                            <br />혼자서도 공부를 잘하는 방법을 가르칩니다.
                        </p>
                    </article>
                </section>

                <section className='bg_pt_blue'>
                    <article className='art-main4'>
                        <p className="display-1">공부를 잘하는 방법을 가르칩니다.</p>
                        <p className="display-4">
                            개별 맞춤 진단을 바탕으로 자기주도훈련을 통해
                            <br />혼자서도 공부를 잘하는 방법을 가르칩니다.
                        </p>
                    </article>
                </section>


                <section className='bg_pt_none'>
                    <Footer />
                </section>

       
            </div>
        </div>
    
    );
}

export default MainPage;